module.exports = __webpack_public_path__ + "components/flag/static/square/cy-be4d55e13bde3fc5449415a640d5620c.svg";